<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明设置协议"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Tabs value="Checkbox" type="card" >
      <TabPane label="选择通道" name="Checkbox">
        <Form ref="setDriverParamsRef" v-model="setDriverParams" :label-width="90">
          <FormItem prop="possword" label="密码">
            <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>
            <Button type="primary" @click="posswordTwo">密码2</Button>
            <Input v-model="setDriverParams.possword" type="password" password placeholder="请输入密码">
            </Input>
          </FormItem>
<!--          <FormItem prop="CC" label="客户代码">-->
<!--            <Input v-model="setDriverParams.CC" placeholder="请输入客户代码">-->
<!--            </Input>-->
<!--          </FormItem>-->
<!--          <FormItem prop="NBB" label="协议版本">-->
<!--            &lt;!&ndash;        <Input v-model="setDriverParams.NBB" placeholder="请输入协议版本">&ndash;&gt;-->
<!--            &lt;!&ndash;        </Input>&ndash;&gt;-->

<!--            <Select v-model="setDriverParams.NBB">-->
<!--              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>-->
<!--            </Select>-->

<!--          </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="从业资格证号">-->
          <!--      <FormItem prop="driverLicenseNum" label="司机卡号">-->
          <!--        <Input v-model="setDriverParams.qualificationCode" placeholder="请输入司机卡号">-->
          <!--        </Input>-->
          <!--      </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="发证机构名称">-->
          <!--        <Input v-model="setDriverParams.organizationNames" placeholder="请输入发证机构名称">-->
          <!--        </Input>-->
          <!--      </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="证件有效期">-->
          <!--        <Input v-model="setDriverParams.indate" placeholder="请输入证件有效期">-->
          <!--        </Input>-->
          <!--      </FormItem>-->

          <FormItem prop="NBB" label="通道">
            <CheckboxGroup v-model="setDriverParams.Checkbox">
              <Checkbox label="1"></Checkbox>
              <Checkbox label="2"></Checkbox>
              <Checkbox label="3"></Checkbox>
              <Checkbox label="4"></Checkbox>
              <Checkbox label="5"></Checkbox>
              <Checkbox label="6"></Checkbox>
            </CheckboxGroup>
          </FormItem>

          <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
          <Button type="primary" @click="onSendDriverCardParams">发送</Button>
        </Form>
      </TabPane>
      <TabPane v-for="item in setDriverParams.Checkbox" v-if="item == 1" label="通道1" name="access1">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[0]" :label-width="90">

                    <FormItem prop="CC" label="客户代码">
                      <Input v-model="setDriverParams.PI[0].CC" placeholder="请输入客户代码">
                      </Input>
                    </FormItem>
                    <FormItem prop="NBB" label="协议版本">
                      <Select v-model="setDriverParams.PI[0].GPS.NBB">
                        <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                      </Select>
                    </FormItem>

        </Form>
      </TabPane>
      <TabPane v-for="item in setDriverParams.Checkbox" v-if="item == 2"  label="通道2" name="access2">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[1]" :label-width="90">

          <FormItem prop="CC" label="客户代码">
            <Input v-model="setDriverParams.PI[1].CC" placeholder="请输入客户代码">
            </Input>
          </FormItem>
          <FormItem prop="NBB" label="协议版本">
            <Select v-model="setDriverParams.PI[1].GPS.NBB">
              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane v-for="item in setDriverParams.Checkbox" v-if="item == 3"  label="通道3" name="access3">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[2]" :label-width="90">

          <FormItem prop="CC" label="客户代码">
            <Input v-model="setDriverParams.PI[2].CC" placeholder="请输入客户代码">
            </Input>
          </FormItem>
          <FormItem prop="NBB" label="协议版本">
            <Select v-model="setDriverParams.PI[2].GPS.NBB">
              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane v-for="item in setDriverParams.Checkbox" v-if="item == 4"  label="通道4" name="access4">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[3]" :label-width="90">

          <FormItem prop="CC" label="客户代码">
            <Input v-model="setDriverParams.PI[3].CC" placeholder="请输入客户代码">
            </Input>
          </FormItem>
          <FormItem prop="NBB" label="协议版本">
            <Select v-model="setDriverParams.PI[3].GPS.NBB">
              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane v-for="item in setDriverParams.Checkbox" v-if="item == 5"  label="通道5" name="access5">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[4]" :label-width="90">

          <FormItem prop="CC" label="客户代码">
            <Input v-model="setDriverParams.PI[4].CC" placeholder="请输入客户代码">
            </Input>
          </FormItem>
          <FormItem prop="NBB" label="协议版本">
            <Select v-model="setDriverParams.PI[4].GPS.NBB">
              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane v-for="item in setDriverParams.Checkbox" v-if="item == 6"  label="通道6" name="access6">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.PI[5]" :label-width="90">

          <FormItem prop="CC" label="客户代码">
            <Input v-model="setDriverParams.PI[5].CC" placeholder="请输入客户代码">
            </Input>
          </FormItem>
          <FormItem prop="NBB" label="协议版本">
            <Select v-model="setDriverParams.PI[5].GPS.NBB">
              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>
    </Tabs>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  export default {
    name: 'rmsetdrivermodal',
    components: {

    },
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        setDriverParams: {
          id: null,
          possword: 'admin',
          qualificationCode: null,
          organizationNames: null,
          indate: null,
          Checkbox:[],
          PI:[
            {CC:null,GPS:{NBB:null}},
            {CC:null,GPS:{NBB:null}},
            {CC:null,GPS:{NBB:null}},
            {CC:null,GPS:{NBB:null}},
            {CC:null,GPS:{NBB:null}},
            {CC:null,GPS:{NBB:null}}
          ]
        },

        JSON:['null','null','null','null','null','null'],

        NBBOptions: [
          {label: '2013协议', value: '0'},
          {label: '2019协议', value: '1'}
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange (val) {
        if (val) {
          this.setDriverParams.id = this._initValue
          this.setDriverParams.qualificationCode = null
          this.setDriverParams.organizationNames = null
          this.setDriverParams.indate = null
          this.possworsOne()
        }
      },
      onCleanDriverCardParams () {
        this.setDriverParams.possword = 'admin'
        this.setDriverParams.qualificationCode = null
        this.setDriverParams.organizationNames = null
        this.setDriverParams.indate = null
      },
      onSendDriverCardParams () {
        // if (this.setDriverParams.CC == null){
        //   this.$Message.error("请输入客户代码")
        // }
        // if (this.setDriverParams.NBB == null){
        //   this.$Message.error("请选择协议版本")
        // }
        // if (this.setDriverParams.NBB != null) {
        //   this.setDriverParams.qualificationCode = this.setDriverParams.NBB
        // }

        console.log(this.setDriverParams)
        for (let i = 0; i < this.setDriverParams.Checkbox.length; i++) {
        console.log(this.JSON)
        console.log(this.setDriverParams.Checkbox[i])
        console.log(this.setDriverParams.PI[this.setDriverParams.Checkbox[i]-1])
        console.log(JSON.stringify(this.JSON[this.setDriverParams.Checkbox[i]-1]))
          this.JSON[this.setDriverParams.Checkbox[i]-1] = JSON.stringify(this.setDriverParams.PI[this.setDriverParams.Checkbox[i]-1])
        console.log(this.JSON[this.setDriverParams.Checkbox[i]-1])
        }

        //99admin,admin,JSON,{"PSI":{"PI":[null,null,null,{"CC":"54","GPS":{"NBB":"0"}},null,null]}}!
        console.log('99admin,' + this.setDriverParams.possword + ',JSON,{"PSI":{"PI":[' + this.JSON + ']}}!')
        let content = '99admin,' + this.setDriverParams.possword + ',JSON,{"PSI":{"PI":[' + this.JSON + ']}}!'
        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this._initValue, content:content, urgent: false }
        }).then(() => {
          this.$Message.success('发送成功')
          this.JSON = ['null','null','null','null','null','null']
        }).catch(err => {
          this.$Message.error(err)
          this.JSON = ['null','null','null','null','null','null']
        })
      },
      possworsOne(){
        this.setDriverParams.possword = 'admin'
      },
      posswordTwo(){
        this.setDriverParams.possword = 'JC336699'
      },
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get () {
          return this.initValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get () {
          return this.terminalNumValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    }
  }
</script>
